import React from 'react'
import { Button, Space } from 'antd'
import WebMain from './WebMain'

function Service() {
    return (
        <WebMain selectedKeys="contact">
            <div
                style={{
                    textAlign: 'center',
                    fontSize: '15px',
                    backgroundColor: '#fff',
                    padding: '24px 16px 40px',
                    color: '#333',
                }}
            >
                <Space direction="vertical" size={20} style={{ width: '100%' }}>
                    <div>
                        如果电脑上已登录微信，请点击{' '}
                        <Button
                            type="primary"
                            size="large"
                            block
                            onClick={() => {
                                window.open('https://work.weixin.qq.com/kfid/kfc3535f6041dfa6172')
                            }}
                        >
                            微信客服
                        </Button>
                    </div>
                    <div>或者打开手机扫码，添加企业微信</div>
                    <div style={{ width: '100%', maxWidth: 360, margin: '0 auto' }}>
                        <img src="./img/home/weixin.png" alt="" style={{ width: '100%', height: 'auto' }} />
                    </div>
                </Space>
            </div>
        </WebMain>
    )
}

export default Service
